module.exports = __webpack_public_path__ + "img/github-brands.49ba8e1.svg";